module.exports = __webpack_public_path__ + "static/media/7.310e05a3.png";